// src/utils/showAlert.js

export const showAlert = (message) => {
    // Create a full-screen overlay
    const overlay = document.createElement("div");
    overlay.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.3); /* Semi-transparent black */
      backdrop-filter: blur(5px); /* Adds blur effect */
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 999; /* Behind the alert */
    `;
  
    // Create the alert box
    const alertBox = document.createElement("div");
    alertBox.textContent = message;
    alertBox.style.cssText = `
      background: #333;
      color: white;
      padding: 16px 24px;
      border-radius: 12px;
      box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);
      text-align: center;
      font-size: 16px;
      font-weight: bold;
      z-index: 1000;
      opacity: 1;
      transition: opacity 0.5s ease-in-out;
    `;
  
    // Append elements
    overlay.appendChild(alertBox);
    document.body.appendChild(overlay);
  
    // Remove alert and overlay after 2 seconds
    setTimeout(() => {
      alertBox.style.opacity = "0";
      overlay.style.opacity = "0";
      setTimeout(() => {
        overlay.remove();
      }, 500);
    }, 3000);
  };
  